var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShrink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76121 10.2388H2.58209C2.41717 10.2388 2.27892 10.1834 2.16735 10.0727C2.05578 9.96198 2 9.82478 2 9.66111C2 9.49744 2.05578 9.35877 2.16735 9.24512C2.27892 9.13146 2.41717 9.07463 2.58209 9.07463H6.2055C6.40947 9.07463 6.58044 9.14362 6.71841 9.28159C6.85638 9.41956 6.92537 9.59053 6.92537 9.7945V13.4179C6.92537 13.5828 6.87001 13.7211 6.75929 13.8326C6.64858 13.9442 6.51138 14 6.34771 14C6.18404 14 6.04537 13.9442 5.93172 13.8326C5.81804 13.7211 5.76121 13.5828 5.76121 13.4179V10.2388ZM10.2388 5.76121H13.4179C13.5828 5.76121 13.7211 5.81657 13.8326 5.92731C13.9442 6.03802 14 6.17522 14 6.33889C14 6.50256 13.9442 6.64123 13.8326 6.75488C13.7211 6.86854 13.5828 6.92537 13.4179 6.92537H9.7945C9.59053 6.92537 9.41956 6.85638 9.28159 6.71841C9.14362 6.58044 9.07463 6.40947 9.07463 6.2055V2.58209C9.07463 2.41717 9.12999 2.27892 9.24071 2.16735C9.35142 2.05578 9.48862 2 9.65229 2C9.81596 2 9.95463 2.05578 10.0683 2.16735C10.182 2.27892 10.2388 2.41717 10.2388 2.58209V5.76121Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrink);
export default __webpack_public_path__ + "static/media/shrink.c11da605abdf5478a87ee8512ccbb4c9.svg";
export { ForwardRef as ReactComponent };